import { ReactElement } from "react";
import {
	Dialog,
	Form,
	FormItem,
	TextInput,
	Toolbar,
	ValidationError
} from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { localize } from "client_legacy/ndaw/culture";

export type AfasOtpDialogProps = {
	attachable: IValueInputAttachable<string>;
	isBusy: boolean;
	onClose: () => void;
	onActivate: () => void;
};

export const AfasOtpDialog = (props: AfasOtpDialogProps): ReactElement => {
	const {
		attachable,
		isBusy,
		onClose,
		onActivate
	} = props;

	return (
		<Dialog
			trackingId="afas-otp-dialog"
			hasBusyIndicator={isBusy}
		>
			<Dialog.Header
				title={localize("_EnterActivationCode")}
			/>
			<Dialog.Body>
				<p>
					{localize("_AfasActivationCodeIsSentToEmailHint")}
				</p>
				<Form onSubmit={onActivate}>
					<FormItem label={localize("_ActivationCode")}>
						<TextInput
							{...attachable.attachToTextInput()}
							placeholder={localize("_EnterActivationCode")}
							autoFocus="focus"
						/>

						<ValidationError {...attachable.attachToValidationError()} />
					</FormItem>
				</Form>
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						trackingId="activate"
						kind="primary"
						text={localize("_Activate")}
						onClick={onActivate}
					/>
					<Toolbar.Button
						trackingId="cancel"
						kind="secondary"
						text={localize("_Cancel")}
						onClick={onClose}
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
AfasOtpDialog.displayName = "AfasOtpDialog";